module.exports = __webpack_public_path__ + "static/img/vu.859836e7.svg";